import React from 'react'
import IMG from "./css.png"
function CSSLogo() {
  return (
    <img src={IMG}style={{width:"200px",height:"150px" }} alt='css' />
  )
}

export default CSSLogo